import { render, staticRenderFns } from "./FooterGolTipster.vue?vue&type=template&id=15b82fb7&scoped=true&"
import script from "./FooterGolTipster.vue?vue&type=script&lang=js&"
export * from "./FooterGolTipster.vue?vue&type=script&lang=js&"
import style0 from "./FooterGolTipster.vue?vue&type=style&index=0&id=15b82fb7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b82fb7",
  null
  
)

export default component.exports